import React from 'react';
import {
  FormControl,
  Box,
  FormHelperText,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useSelector } from 'react-redux';

import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';

const buildModelList = (models) => {
  if (!models) return [];
  return models
    .filter((model) => model.status === 'ready')
    .map((model) => ({
      key: model.name,
      text: model.name,
      value: model.model_uuid,
    }));
};

export default function ModelUriField({
  value,
  sourceType,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  copy,
}) {
  const models = useSelector((state) => state.models || []);

  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);

    if (sourceType === THIRD_PARTY_TYPES.TRAINML.value) {
      setError(false);
    } else {
      const uriTest = Object.values(THIRD_PARTY_TYPES).find(
        (type) => type.value === sourceType
      )?.uriTest;
      if (uriTest) {
        const valid = uriTest.test(newValue);
        setError(!valid);
      }
    }
  };

  const selected_type = Object.values(THIRD_PARTY_TYPES).find(
    (type) => type.value === sourceType
  );
  const placeholder = selected_type ? selected_type.uriExample : '';

  if (sourceType === THIRD_PARTY_TYPES.TRAINML.value) {
    const modelList = buildModelList(models);
    return (
      <Box>
        <FormControl fullWidth>
          <InputLabel id='model-uri-label'>Model</InputLabel>
          <Select
            labelId='model-uri-label'
            id='source_uri'
            value={value || ''}
            label='Model'
            aria-describedby='model-uri-helper-text'
            onChange={handleChange}
            disabled={edit || copy}
          >
            {modelList.map((model) => (
              <MenuItem key={model.value} value={model.value}>
                {model.text}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText id='model-uri-helper-text'>
            Select a model
          </FormHelperText>
        </FormControl>
      </Box>
    );
  }

  if (!sourceType) {
    return null;
  }

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Model Code Location'
          id='source_uri'
          aria-describedby='model-uri-helper-text'
          variant='outlined'
          fullWidth
          placeholder={placeholder}
          onChange={handleChange}
          error={Boolean(error)}
          value={value || ''}
          disabled={edit || copy}
        />
        {error ? (
          <FormHelperText id='model-uri-helper-text' error>
            Model Path Invalid
          </FormHelperText>
        ) : (
          <FormHelperText id='model-uri-helper-text'>
            Enter the model code location
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

